import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
    const nav = useNavigate();
    const { refresh } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const hash = window.location.hash || "";
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const sid = params.get("session_id");
        if (!sid) { nav("/login", { replace: true }); return; }
        (async () => {
            try {
                await api.post("/auth/session", null, { headers: { "X-Session-ID": sid } });
                await refresh();
                toast.success("Signed in");
                // Strip the hash and go to dashboard
                window.history.replaceState({}, "", "/");
                nav("/dashboard", { replace: true });
            } catch (e) {
                toast.error("Sign-in failed");
                nav("/login", { replace: true });
            }
        })();
    }, [nav, refresh]);

    return (
        <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm" data-testid="auth-callback">
            Completing sign-in…
        </div>
    );
}
